export enum Border {
  PX_0 = 0,
  PX_1 = 1,
  PX_2 = 2,
  PX_3 = 3,
  PX_4 = 4,
  PX_5 = 5,
  PX_6 = 6,
  PX_7 = 7,
  PX_8 = 8,
  PX_9 = 9,
  PX_10 = 10,
  PX_12 = 12,
  PX_14 = 14,
  PX_16 = 16,
  PX_18 = 18,
  PX_20 = 20,
  PX_24 = 24,
  PX_28 = 28,
  PX_32 = 32,
  PX_36 = 36,
  PX_40 = 40,
  PX_44 = 44,
  PX_48 = 48,
  PX_56 = 56,
  PX_64 = 64,
  PX_80 = 80,
  PX_96 = 96,
  PX_112 = 112,
  PX_128 = 128,
  PX_144 = 144,
  PX_160 = 160,
  PX_176 = 176,
  PX_192 = 192,
  PX_208 = 208,
  PX_224 = 224,
  PX_240 = 240,
  PX_256 = 256,
  PX_288 = 288,
  PX_320 = 320,
  PX_384 = 384,
}
